import React from 'react';

import { MenuItem, TextField, Typography } from '@mui/material';

interface Props<T extends string> {
  label: string;
  labels: Record<T, string>;
  value: T | null;
  onChange: (value: T | null) => void;
  /** Whether "Not set" is offered; off for fields that always have a value. */
  clearable?: boolean;
}

export default function NativeTourEnumSelect<T extends string>({
  label,
  labels,
  value,
  onChange,
  clearable = true,
}: Props<T>) {
  return (
    <TextField
      select
      label={label}
      value={value ?? ''}
      onChange={(event) => onChange((event.target.value || null) as T | null)}
      fullWidth
    >
      {clearable && (
        <MenuItem value="">
          <Typography fontStyle="italic">Not set</Typography>
        </MenuItem>
      )}
      {(Object.keys(labels) as Array<T>).map((key) => (
        <MenuItem key={key} value={key}>
          {labels[key]}
        </MenuItem>
      ))}
    </TextField>
  );
}
